import * as React from 'react';
import './faqCategoryView.module.scss';
import { CardFaqView } from './CardFaqView';
import { FaqCategoryShowView } from '../../../types/faqs';

type Props = {
    category: FaqCategoryShowView;
};

export class FaqCategoryView extends React.Component<Props> {
    render() {
        const { category } = this.props;
        return (
            <div styleName="card-category-view">
                <h4 id={'c' + category.id} styleName="section-sub-header">
                    {category.title}
                </h4>
                {category.faqs.map((q) => <CardFaqView key={q.id} faq={q} />)}
            </div>
        );
    }
}
